export default "__VITE_ASSET__nEE0fxRe__"